import React from "react";

// Compact "Delivered ✓ · Opened 2h ago" pills derived from Resend
// webhook stamps. Hidden when no events have arrived yet. Used inside
// ShareLinksModal next to each emailed_to row.
export function DeliveryBadges({ entry }) {
    const since = (iso) => {
        if (!iso) return "";
        const ms = Date.now() - new Date(iso).getTime();
        if (ms < 0 || Number.isNaN(ms)) return "";
        const min = Math.floor(ms / 60000);
        if (min < 1) return "just now";
        if (min < 60) return `${min}m ago`;
        const h = Math.floor(min / 60);
        if (h < 24) return `${h}h ago`;
        return `${Math.floor(h / 24)}d ago`;
    };
    const items = [];
    if (entry.bounced_at) {
        items.push({
            key: "bounced",
            label: `Bounced ${since(entry.bounced_at)}`,
            cls: "border-red-400/40 text-red-300 bg-red-500/10",
        });
    }
    if (entry.complained_at) {
        items.push({
            key: "complained",
            label: `Spam complaint ${since(entry.complained_at)}`,
            cls: "border-rose-400/40 text-rose-300 bg-rose-500/10",
        });
    }
    if (entry.delivered_at) {
        items.push({
            key: "delivered",
            label: `Delivered ${since(entry.delivered_at)}`,
            cls: "border-[#00C853]/40 text-[#00E676] bg-[#00C853]/10",
        });
    }
    if (entry.opened_at) {
        items.push({
            key: "opened",
            label: `Opened ${since(entry.opened_at)}`,
            cls: "border-[#1a3fd1]/40 text-[#8fa4f0] bg-[#1a3fd1]/10",
        });
    }
    if (entry.clicked_at) {
        items.push({
            key: "clicked",
            label: `Clicked ${since(entry.clicked_at)}`,
            cls: "border-violet-400/40 text-violet-300 bg-violet-500/10",
        });
    }
    if (items.length === 0) return null;
    return (
        <span className="flex items-center gap-1 flex-wrap" data-testid="quote-share-delivery-badges">
            {items.map((it) => (
                <span
                    key={it.key}
                    className={`inline-flex items-center text-[9px] uppercase tracking-wider font-bold px-1.5 py-0.5 rounded-full border ${it.cls}`}
                    data-testid={`quote-share-delivery-${it.key}`}
                >
                    {it.label}
                </span>
            ))}
        </span>
    );
}
